import React from 'react'
import { Modal, Header, Button, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'

class EdiModal extends React.Component {
  
  cancleClick = (event, data) => {
    this.props.handleClose();
  }

  render() {
    const{ediMessage} = this.props;
    return (
      <Modal 
        // closeIcon={this.props.modalOpen == false}
        open={this.props.modalOpen}
        size='large'
        closeOnEscape={true}
        closeOnRootNodeClick={true}
      >
        <Header>
        <div className="ediModalHeader">
          <div>
            Statement No: {this.props.statementNumber}
          </div>
          {/* <div>
           Date: 123456
          </div> */}
        </div>
        </Header>
        <Modal.Content className="ediGridHolder">
          <div>
            {ediMessage && ediMessage.map(edi => {
              let print =edi.toString().split("");
              return(
                <ul className='ediGrid'>
                  {print.map(letter => {
                    return(
                      <li style={{border: "solid 1px black", padding: "3px"}}>
                      {letter}
                    </li>
                    )
                  })}
                </ul>
              )
            })}
          </div>
          {!ediMessage && <p>No EDI Message found for the statement</p>}
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            type='button'
            icon='remove'
            labelPosition='right'
            onClick={this.cancleClick}
            content='Close'
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

EdiModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  valueIntoModal: PropTypes.string.isRequired
}

export default EdiModal